import moment from "moment";

export const sortApiVersions = (versions: string[]) => {
    const sortedVersions = versions.sort((a, b) => {
        const dateA = moment(a, 'MM-YYYY');
        const dateB = moment(b, 'MM-YYYY');
        return dateA.isBefore(dateB) ? 1 : -1;
    });
    return sortedVersions;
}
